module.exports = __webpack_public_path__ + "media/images/rank/silver-lg-0ce6bea64a37ee85ce38f78ea6be9219.svg";